import gql from 'graphql-tag';
import { PageInfoFragment } from 'components/shared/fragments';

const EquipmentListItemFragment = gql`
  fragment EquipmentListItem on Equipment {
    id
    name
    updatedAt
    lastPublishedAt
    organization {
      id
      name
      slug
    }
  }
`;

export const EQUIPMENT_LIST = gql`
  query EquipmentList(
    $first: Int
    $after: String
    $before: String
    $last: Int
    $filters: FilterOrganizationEquipmentInput
    $organizationId: ID!
  ) {
    organization(id: $organizationId) {
      id
      equipments(
        first: $first
        after: $after
        before: $before
        last: $last
        filters: $filters
      ) {
        edges {
          node {
            ...EquipmentListItem
          }
        }
        pageInfo {
          ...PageInfo
        }
      }
    }
  }
  ${PageInfoFragment}
  ${EquipmentListItemFragment}
`;
